import { Component, ViewChild } from '@angular/core';
import { BaseForm } from '@forms/base.form';
import { NgForm } from '@angular/forms';
import { TimeOffPolicy } from '@models/time-off-v3/time-off-policy.model';
import moment, { Moment } from 'moment';

const DATE_HIRED = 0;
const CUSTOM_DATE = 1;

@Component({
    selector: 'app-reassign-policy-form',
    templateUrl: './policy-reassign.template.html',
    styleUrls: ['./policy-reassign.style.scss'],
})
export class PolicyReassignForm extends BaseForm {
    @ViewChild('form') form: NgForm;
    policies: TimeOffPolicy[] = [];
    selectPolicy: number;
    sourcePolicy: TimeOffPolicy;
    effectiveAtType = 0;
    effectiveAtOptions = [
        { value: DATE_HIRED, label: 'time-off-v3.dateHired' },
        { value: CUSTOM_DATE, label: 'time-off-v3.selectDate' },
    ];
    effectiveAt: Moment;

    get isCustomDate(): boolean {
        return this.effectiveAtType === CUSTOM_DATE;
    }

    beforeShow(): void {
        this.selectPolicy = this.policies[0].id;
        this.effectiveAtType = DATE_HIRED;
        this.effectiveAt = moment();
    }
}
